import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e185701"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-list" }
const _hoisted_2 = {
  key: 0,
  class: "group-list__loading"
}

import { NTabs, NTabPane } from 'naive-ui'
import GroupList from '@teams/common/components/groupList/groupList.vue'
import GroupItem from './groupItem.vue'
import Icon from '@teams/common/components/icon'
import { h, ref, watch } from 'vue'
import SelectTemplate from '../dialog/createGroup/selectTemplate/index.vue'
import { useGroupStore } from '@teams/common/store/group'
import Loading from '@teams/common/components/loading'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const defaultValue = ref('')
const groupStore = useGroupStore()
const mineListRef = ref<{ loading: boolean }>()
const latestListRef = ref<{ loading: boolean }>()
const starListRef = ref<{ loading: boolean }>()

const handleUpdateValue = (value: string) => {
  defaultValue.value = value
}

const changeTab = () => {
  if (
    groupStore.groups.find(item => item.id === groupStore.current.id) ||
    groupStore.stickyTopGroups.find(item => item.id === groupStore.current.id)
  ) {
    defaultValue.value = 'mine'
  } else if (
    groupStore.recentAccessGroups.find(
      item => item.id === groupStore.current.id
    )
  ) {
    defaultValue.value = 'latest'
  } else if (
    groupStore.starGroups.find(item => item.id === groupStore.current.id)
  ) {
    defaultValue.value = 'star'
  } else {
    defaultValue.value = 'mine'
  }
}

watch(
  [() => mineListRef.value?.loading, () => latestListRef.value?.loading],
  () => {
    if (
      mineListRef.value?.loading === false &&
      latestListRef.value?.loading === false &&
      !defaultValue.value
    ) {
      changeTab()
    }
  },
  {
    immediate: true
  }
)

const emptyIcon = () => {
  return h(Icon, {
    name: 'noGroupList',
    size: 100
  })
}

const notLoginIcon = () => {
  return h(Icon, {
    name: 'groupListNotLogin',
    size: 100
  })
}

const loadingMoreIcon = () => {
  return h(Icon, {
    name: 'loadingGroupList',
    size: 16
  })
}

const loadingIcon = () => {
  return h(Icon, {
    name: 'loading',
    size: 32
  })
}

const errorIcon = () => {
  return h(Icon, {
    name: 'wifi',
    size: 100
  })
}

const addIcon = () => {
  return h(Icon, {
    name: 'addSpace',
    size: 40,
    fill: 'transparent'
  })
}

const createSpace = (obj?: { noModal?: boolean }) => {
  return h(SelectTemplate, {
    addIcon: addIcon,
    // TODO: 后续要把 modal 独立出来！！！不要用这种方式
    noModal: obj?.noModal ?? false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!defaultValue.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Loading), { useType: 'pc' })
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_unref(NTabs), {
      value: defaultValue.value,
      animated: false,
      class: "tab",
      "justify-content": "space-evenly",
      size: "small",
      onUpdateValue: handleUpdateValue
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NTabPane), {
          name: "mine",
          tab: "我的",
          "display-directive": "show"
        }, {
          default: _withCtx(() => [
            _createVNode(GroupList, {
              "list-type": "mine",
              "pull-refresh": null,
              "pull-refresh-props": {},
              "empty-icon": emptyIcon,
              "loading-more-icon": loadingMoreIcon,
              "loading-icon": loadingIcon,
              "error-icon": errorIcon,
              "create-space-component": createSpace,
              ref_key: "mineListRef",
              ref: mineListRef,
              "not-login-icon": notLoginIcon
            }, {
              item: _withCtx((item) => [
                _createVNode(GroupItem, {
                  name: item.itemprop.name,
                  id: item.itemprop.id,
                  "is-select": !!item.itemprop.isSelect,
                  avatar: item.itemprop.avatar,
                  "sticky-top": item.itemprop.stickyTop,
                  "group-item-source-type": item.itemprop.groupItemSourceType,
                  auth: item.itemprop.auth,
                  "space-type": item.itemprop.spaceType
                }, null, 8, ["name", "id", "is-select", "avatar", "sticky-top", "group-item-source-type", "auth", "space-type"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }),
        _createVNode(_unref(NTabPane), {
          name: "latest",
          tab: "最近",
          "display-directive": "show"
        }, {
          default: _withCtx(() => [
            _createVNode(GroupList, {
              "list-type": "latest",
              "pull-refresh": null,
              "pull-refresh-props": {},
              "empty-icon": emptyIcon,
              "loading-more-icon": loadingMoreIcon,
              "loading-icon": loadingIcon,
              "error-icon": errorIcon,
              ref_key: "latestListRef",
              ref: latestListRef,
              "not-login-icon": notLoginIcon
            }, {
              item: _withCtx((item) => [
                _createVNode(GroupItem, {
                  name: item.itemprop.name,
                  id: item.itemprop.id,
                  "is-select": item.itemprop.isSelect,
                  avatar: item.itemprop.avatar,
                  "group-item-source-type": item.itemprop.groupItemSourceType,
                  auth: item.itemprop.auth,
                  "space-type": item.itemprop.spaceType
                }, null, 8, ["name", "id", "is-select", "avatar", "group-item-source-type", "auth", "space-type"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }),
        _createVNode(_unref(NTabPane), {
          name: "star",
          tab: "星标",
          "display-directive": "show"
        }, {
          default: _withCtx(() => [
            _createVNode(GroupList, {
              "list-type": "star",
              "pull-refresh": null,
              "pull-refresh-props": {},
              "empty-icon": emptyIcon,
              "loading-more-icon": loadingMoreIcon,
              "loading-icon": loadingIcon,
              "error-icon": errorIcon,
              ref_key: "starListRef",
              ref: starListRef,
              "not-login-icon": notLoginIcon
            }, {
              item: _withCtx((item) => [
                _createVNode(GroupItem, {
                  name: item.itemprop.name,
                  id: item.itemprop.id,
                  "is-select": item.itemprop.isSelect,
                  avatar: item.itemprop.avatar,
                  "group-item-source-type": item.itemprop.groupItemSourceType,
                  auth: item.itemprop.auth,
                  "space-type": item.itemprop.spaceType
                }, null, 8, ["name", "id", "is-select", "avatar", "group-item-source-type", "auth", "space-type"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]), [
      [_vShow, !!defaultValue.value]
    ])
  ]))
}
}

})